// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"e88175f42346ef608bea","731":"0256dcc31ce9fd40ce8e","843":"f82bde2882a95dfe96d3","883":"0ad15ce45eb683d45696"}[chunkId] + ".js";
};